import { supabase } from './supabase';

const birthDataService = {
  // Get user's birth data
  getBirthData: async (userId) => {
    try {
      const { data, error } = await supabase
        .from('birth_data')
        .select('*')
        .eq('user_id', userId)
        .single()
      
      if (error) {
        return { success: false, error: error.message }
      }
      
      return { success: true, data }
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          success: false, 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        }
      }
      return { success: false, error: 'Failed to load birth data' }
    }
  },

  // Create or update birth data
  saveBirthData: async (userId, birthData) => {
    try {
      const { data, error } = await supabase
        .from('birth_data')
        .upsert({
          user_id: userId,
          ...birthData
        })
        .select()
        .single()
      
      if (error) {
        return { success: false, error: error.message }
      }
      
      return { success: true, data }
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          success: false, 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        }
      }
      return { success: false, error: 'Failed to save birth data' }
    }
  },

  // Delete birth data
  deleteBirthData: async (userId) => {
    try {
      const { error } = await supabase
        .from('birth_data')
        .delete()
        .eq('user_id', userId)
      
      if (error) {
        return { success: false, error: error.message }
      }
      
      return { success: true }
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          success: false, 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        }
      }
      return { success: false, error: 'Failed to delete birth data' }
    }
  }
}

export default birthDataService